<div
  class="animate-in fade-in slide-in-from-bottom-2 flex flex-col gap-4 rounded-[12px] border border-gray-100 bg-white p-5 shadow-xl duration-500">
  <div class="flex flex-col gap-1.5 border-b-2 border-gray-300 pb-3">
    <h2 class="title text-[18px] font-bold" i18n="@@stock.currentStock">Current Stock</h2>
  </div>
  <app-stock-filters
    [(filters)]="filters"
    [(productSearchTerm)]="productSearchTerm"
    [(showProductTitleDropdown)]="showProductTitleDropdown"
    [isCurrentStockMode]="true"
    [isProductLevel]="true"
    [hasSubProducts]="hasSubProducts()"
    [parentProductId]="productId()"
    [suppliers]="suppliers()"
    [stockTypes]="stockTypes()"
    [productTitleLoading]="false"
    [productTitleResults]="[]"
    (applyFilters)="loadData()"
    (resetFilters)="resetFilters()"
    (toggleSortOrder)="toggleOrder()" />

  @if (loading()) {
    <app-loading />
  } @else if (error()) {
    <app-error-data
      title="Failed to load stock data"
      i18n-title="@@stock.errorTitle"
      description="Something went wrong while fetching the data. Please try again."
      i18n-description="@@stock.errorDesc"
      [showRetry]="true"
      (retry)="loadData()" />
  }
  <!-- @else if (allStockData().length === 0) {
        <app-empty-data
          [title]="noDataTitle"
          i18n-title="@@noSubProductsFoundArtitle"
          [description]="noDataSubTitle"
          i18n-description="@@noSubProductsFoundAr"
          />
      }  -->
  @else {
    <app-current-stock-table
      [allStockData]="allStockData()"
      [startItem]="startItem()"
      [totalItems]="totalElements()"
      [currentPage]="currentPage()"
      [itemsPerPage]="itemsPerPage"
      [totalPages]="totalPages()"
      [pageNumbers]="getPageNumbers()"
      (previousPage)="previousPage()"
      (nextPage)="nextPage()"
      (goToPage)="goToPage($event)" />
  }
</div>